import { styled } from "@pigment-css/react";

const Pill = styled("div")<{ align: "center" | "start" }>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[4],
  variants: [
    { props: { align: "center" }, style: { alignItems: "center" } },
    { props: { align: "start" }, style: { alignItems: "flex-start" } },
  ],
  minWidth: 0,
  maxWidth: "100%",
  height: theme.fieldSalesTwo.spacing[48],
  padding: `0 ${theme.fieldSalesTwo.spacing[20]}`,
  borderRadius: theme.fieldSalesTwo.radius.circular,
  background: theme.fieldSalesTwo.colors.surface.glassStrong,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorderStrong}`,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
}));

const Name = styled("span")(({ theme }) => ({
  maxWidth: "100%",
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

const Reference = styled("span")(({ theme }) => ({
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  // Tighter than the name's so both lines fit the fixed-height pill.
  lineHeight: theme.fieldSalesTwo.font.lineHeight[120],
  color: theme.fieldSalesTwo.colors.neutral[600],
}));

interface CustomerPillProps {
  name: string;
  reference: string;
  align?: "center" | "start";
}

/** Two-line customer identity pill shown in the TopNav of both recap edit screens. */
export function CustomerPill({ name, reference, align = "center" }: CustomerPillProps) {
  return (
    <Pill align={align}>
      <Name>{name}</Name>
      {reference && <Reference>{reference}</Reference>}
    </Pill>
  );
}
